import cookieHelper from "./users/src/helpers/cookieHelper";


var orders;

var queryStringCleanParams =   [
    /(&integration_id=|integration_id)=\d*/,
    /(&integration_system_id|integration_system_id)=\d*/,
    /(&order_id|order_id)=\d*/,
    /(&customer_id|customer_id)=\d*/,
    /(&page|page)=\d*/
]           ;

import  {QueryStringHelper}  from './helpers/queryString';
import moment from 'moment';


(function ($, QueryStringHelper,moment) {
    'use strict';

    $("#erp_combos").change(function() {

        $(".companies_select").css("display", "none")

        let str = '';
        $( "#erp_combos option:selected" ).each(function() {
            str += $( this ).val();
        });
        $("#"+str+"_companies").css("display", "block")
    });

    orders = {};
    orders.retry = function (e) {
        e.preventDefault();
        var url = $(this).attr("href");
        var orderId = $(this).data("order-id");
        $.ajax({
            type: "POST",
            url: url,
            data:{orderId:orderId},
            success:function () {
                location.reload();
            }
        });
    };

    // calculo la fecha de fin del fomulario de busqueda de ordenes
    // si el rango de fecha supera los tres meses debo reasignar el valor de fecha hasta
    document.getElementById('date_from').addEventListener('change', function(event) {
        var _dateFrom = new Date(event.target.value)
        var _dateTo = new Date(document.getElementById('date_to').valueAsDate)

        if(isNaN(_dateFrom)){   // valido que sea una fecha correcta
            console.log("No es una fecha correcta");
            return
        }
        if ((_dateTo - _dateFrom) / (1000 * 60 * 60 * 24) < 92 && (_dateTo - _dateFrom) / (1000 * 60 * 60 * 24) > 0) // si es menor a 92 días
        {
            return
        }
        dateTo.setMonth(dateFrom.getMonth()+3)
        document.getElementById('date_to').valueAsDate = dateTo;
        return
    });


    // orders.markAsProcessed = function (e) {
    //     e.preventDefault();
    //     let orderId = $(this).data("order-id");
    //     $.ajax({
    //         type: "POST",
    //         url: url,
    //         data:{orderId:orderId},
    //         success:function () {
    //             location.reload();
    //         }
    //     });
    //     alert(orderId);
    // }

    // $("#integration_id").on('change', function (e) {
    //     var optionSelected = $(this).find("option:selected");
    //     var valueSelected  = optionSelected.val();
    //     window.location.href = origin+"/orders?integration_id="+valueSelected;
    // });

    $("#integration_system_id").on('change', (function (e) {
        var newSelected = $(this).find("option:selected");
        //var integrationId =  $("#integration_id").val();
        let integrationId = cookieHelper.readCookie("inv_integrationId");
        var valueSelected = newSelected.val();
        if(valueSelected == 0){
            window.location.href = origin+"/orders?integration_id="+integrationId;                                                                                ;
        }else{
            window.location.href = origin+"/orders?integration_id="+integrationId+"&integration_system_id="+valueSelected;                                                                                ;
        }
    }));

    $("#customer_id").on('change', function (e) {
        var newSelected = $(this).find("option:selected");
        var integrationId =  $("#integration_id").val();
        var integrationSystemId = $("#integration_system_id").val();
        window.location.href = origin+"/orders?integration_id="+integrationId+"&integration_system_id="+integrationSystemId+"customer_id="+newSelected;
    });

    orders.myFunction = function(e) {
        e.preventDefault();
    }

    orders.searchFunction = function (e) {
        //    document.getElementById("myDropdown").classList.toggle("show");
        let url = "";
        $("#myDropdown").empty();
        let filter =  $("#searchInput").val();
        if (filter.length<3){
            return;
        }else{
            url = '/api/v1/customers?filter='+filter;
        }

        $.ajax({
            url : url,
            dataType : 'json',
            headers: {'Authorization': 'Bearer '+ getCookie("auth_token")},
            // El resto del código
            success : function(json) {
                json.results.forEach(element => orders.processSearchResultElem(element));
            }
        })
    }

    orders.processSearchResultElem = function(elem){
        let queryString = document.location.search;
        let appendElem;
        let separator = '&';
        let str = "customer_id="+elem.id;
        let url = document.location.protocol + '//' + document.location.host + document.location.pathname;
        queryString = QueryStringHelper.cleanParams(queryString,queryStringCleanParams);
        let hasCustumerId = queryString.includes("customer_id=");
        if(queryString === "?"){
            queryString = "";
        }
        if(queryString === ""){
            separator = "?";
        }
        if(!hasCustumerId){
            appendElem = "<a class=\'result_link\' href=\'"+ url+queryString+separator+str+"\'>"+elem.name+"</a>";
        }else{
            queryString = queryString.replace(/customer_id=\d*/,str);
            queryString = queryString.replace(/order_id=\d*/,"");
            let description = elem.name + ((elem.meli_alias != null && elem.meli_alias !== "") ? " | "+elem.meli_alias :"");
            description = ((description.length<22) ? description : description.substring(0,22) + "..");
            appendElem = "<a class=\'result_link\' href=\'"+url+queryString+"\'>"+description+"</a>";
        }
        $("#myDropdown").append(appendElem);
    }

    orders.processOrdersSearchResultElem = function(elem){
        let queryString = document.location.search;
        let appendElem;
        let separator = '&';
        let str = "order_id="+elem.id;
        let url = document.location.protocol + '//' + document.location.host + document.location.pathname;
        queryString = QueryStringHelper.cleanParams(queryString,queryStringCleanParams);

        let hasOrderId = queryString.includes("order_id=");
        if(queryString === "?"){
            queryString = "";
        }
        if(queryString === ""){
            separator = "?";
        }
        if(!hasOrderId){
            appendElem = "<a class=\'result_link\' href=\'"+ url+queryString+separator+str+"\'>"+elem.order_number+"</a>";
        }else{
            queryString = queryString.replace(/order_id=\d*/,str);
            queryString = queryString.replace(/customer_id=\d*/,"");
            let description = elem.order_number;
            appendElem = "<a class=\'result_link\' href=\'"+url+queryString+"\'>"+description+"</a>";
        }
        $("#myDropdown2").append(appendElem);
    }

    orders.searchOrderFunction = function (e) {
        //    document.getElementById("myDropdown").classList.toggle("show");
        let url = "";
        $("#myDropdown2").empty();
        let filter =  $("#searchOrders").val();
        if (filter.length<3){
            return;
        }else{
            url = '/api/v1/orders/search?text_filter='+filter;
        }

        $.ajax({
            url : url,
            dataType : 'json',
            headers: {'Authorization': 'Bearer '+ getCookie("auth_token")},
            // El resto del código
            success : function(json) {
                json.forEach(element => orders.processOrdersSearchResultElem(element));
            }
        })
    }

    function filterFunction() {
        var input, filter, ul, li, a, i, div, txtValue;
        input = document.getElementById("myInput");
        filter = input.value.toUpperCase();
        div = document.getElementById("myDropdown");
        a = div.getElementsByTagName("a");
        for (i = 0; i < a.length; i++) {
            txtValue = a[i].textContent || a[i].innerText;
            if (txtValue.toUpperCase().indexOf(filter) > -1) {
                a[i].style.display = "";
            } else {
                a[i].style.display = "none";
            }
        }
    }


    $("#only_failed_orders").on('click',function () {
        let newUrl = window.location.origin+"/orders?";
        var searchParams =  new URLSearchParams(window.location.search);
        searchParams.set("only_failed_orders",$('#only_failed_orders').is(':checked')?$('#only_failed_orders').val():false);
        let isFirst = true;

        for (let item of searchParams) {
            newUrl = !isFirst ? newUrl+"&":newUrl;
            newUrl = newUrl+item[0]+"="+item[1];
            isFirst = false;
        }

        window.location.href = newUrl;
    });

    $("#cancelled_orders").on('click',function () {
        let newUrl = window.location.origin+"/orders?";
        var searchParams =  new URLSearchParams(window.location.search);
        searchParams.set("cancelled_orders",$('#cancelled_orders').is(':checked')?$('#cancelled_orders').val():false);
        let isFirst = true;

        for (let item of searchParams) {
            newUrl = !isFirst ? newUrl+"&":newUrl;
            newUrl = newUrl+item[0]+"="+item[1];
            isFirst = false;
        }

        window.location.href = newUrl;
    });

    $("#only_draft").on('click',function () {
        let newUrl = window.location.origin+"/orders?";
        var searchParams =  new URLSearchParams(window.location.search);
        if(searchParams.has('only_confirmed')){
            searchParams.delete("only_confirmed");
        }
        searchParams.set("only_draft",$('#only_draft').is(':checked')?$('#only_draft').val():false);
        let isFirst = true;

        for (let item of searchParams) {
            newUrl = !isFirst ? newUrl+"&":newUrl;
            newUrl = newUrl+item[0]+"="+item[1];
            isFirst = false;
        }

        window.location.href = newUrl;
    });

    $("#only_confirmed").on('click',function () {
        let queryString = document.location.search;
        let newUrl = window.location.origin+"/orders?";
        var searchParams =  new URLSearchParams(window.location.search);
        if(searchParams.has('only_draft')){
            searchParams.delete("only_draft");
        }
        searchParams.set("only_confirmed",$('#only_confirmed').is(':checked')?$('#only_confirmed').val():false);
        let isFirst = true;

        for (let item of searchParams) {
            newUrl = !isFirst ? newUrl+"&":newUrl;
            newUrl = newUrl+item[0]+"="+item[1];
            isFirst = false;
        }

        window.location.href = newUrl;
    });

    orders.searchByDates = function (e) {
        let dateFrom = $('#date_from').val();
        let dateTo =   $('#date_to').val();

        if(dateTo.length < 10 || dateFrom.length < 10){
            document.getElementById('messajeJS').style.display="inline";
            document.getElementById('messageJSContent').innerText = "Fecha desde y hasta deben ser completadas.";
            return;
        }

        if(!validatePeriod(dateFrom, dateTo, 92)){
            document.getElementById('messajeJS').style.display="inline";
            document.getElementById('messageJSContent').innerText = "El período de consulta no debe superar los 3 meses.";
            return;
        }

        let queryString = document.location.search;
        let newUrl = window.location.origin+"/orders?";
        var searchParams =  new URLSearchParams(window.location.search);

        if(searchParams.has('date_from')){
            searchParams.delete("date_from");
        }
        if(searchParams.has('date_to')){
            searchParams.delete("date_to");
        }
        if(dateFrom !== "") {
            searchParams.set("date_from", dateFrom);
            searchParams.delete("order_id");
        }
        if(dateTo !== "") {
            searchParams.set("date_to", dateTo);
            searchParams.delete("order_id");
        }
            let isFirst = true;

            for (let item of searchParams) {
                newUrl = !isFirst ? newUrl+"&":newUrl;
                newUrl = newUrl+item[0]+"="+item[1];
                isFirst = false;
            }

            window.location.href = newUrl;
    };

    $("#excelLink").on('click',function () {
        let queryString = document.location.search;
        let url = document.location.protocol + '//' + document.location.host + document.location.pathname;
        let str = "excel=true";
        let separator = '?';

        if(queryString === ""){
            var newUrl = url+separator+str;
        }else{
            separator = "&";
            newUrl = url+queryString+separator+str;
        }

        window.location.href = newUrl;
    });


    $(".retry_class").on('click', orders.retry);
    $(".mark_as_processed_class").on('click', orders.markAsProcessed);
    $(".result_link").on('click', orders.myFunction);
    $("#searchInput").keyup(orders.searchFunction);
    $("#searchOrdersBtn").on('click',orders.searchOrderFunction);
    $("#searchByDates").on('click',orders.searchByDates);

    $("body").click
    (
        function(e)
        {
            if(e.target.className !== "myDropdown")
            {
                $("#myDropdown").empty();
            }
        }
    );
})(jQuery,QueryStringHelper,moment);


// valido que no se superen los 3 meses de diferencia entre la fecha desde y hasta
function validatePeriod(dateFrom, dateTo, days)
{
    var dateFrom = new Date(dateFrom);
    var dateTo = new Date(dateTo);
    if(parseInt((dateTo - dateFrom) / (1000 * 60 * 60 * 24)) > days){
        return false
    }
    return true;
}


function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}




// WEBPACK FOOTER //
// ./resources/assets/js/orders.js